import { DataserviceService } from '../dataservice.service';
import { Component } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
@Component({
  selector: 'app-quizzes',
  templateUrl: './quizzes.component.html',
  styleUrl: './quizzes.component.css'
})
export class QuizzesComponent {

  currentUser: any;
  quizzes: any[] = [];
  loading: boolean = false;
  addQuizModal: boolean = false;
  editQuizModal: boolean = false;
  deleteQuizModal: boolean = false;
  assignQuizModal: boolean = false;
  assignCompanyModal: boolean = false;
  addQuizForm: FormGroup;
  editQuizForm: FormGroup;
  assignQuizForm: FormGroup;
  assignCompanyForm: FormGroup;
  loadingUsers: boolean = false;
  videoUploading: boolean = false;
  distributors: any[] = [];
  companies: any[] = [];
  providers: any[] = [];
  users: any[] = [];
  statuses: any[] = ['active', 'inactive'];
  selectedQuiz: any;
  constructor(private d: DataserviceService, private message: NzMessageService, private fb: FormBuilder) {
    this.currentUser = JSON.parse(localStorage.getItem('user') || '{}');
    this.addQuizForm = this.fb.group({
      name: ['', Validators.required],
      status: [this.statuses[0], Validators.required],
      distributor_id: ['', Validators.required],
      company_id: ['', Validators.required],
      provider_id: ['', Validators.required],
      percentage_need_to_pass: [0, Validators.required],
      video_url: [''],
      questions: this.fb.array([])
    });
    this.editQuizForm = this.fb.group({
      name: ['', Validators.required],
      status: [this.statuses[0], Validators.required],
      distributor_id: ['', Validators.required],
      company_id: ['', Validators.required],
      provider_id: ['', Validators.required],
      percentage_need_to_pass: [0, Validators.required],
      video_url: [''],
      questions: this.fb.array([])
    });
    this.assignQuizForm = this.fb.group({
      users: [[], Validators.required]
    });
    this.assignCompanyForm = this.fb.group({
      company_id: [this.canMultiAssignCompanies() ? [] : '', Validators.required],
      provider_id: ['generic', Validators.required],
      assign_type: ['all', Validators.required]
    });
  }

  ngOnInit() {
    this.getQuizzes();
    this.getDistributors();
    this.getCompanies();
    this.getProviders();
    this.getUsers();
    if (!this.questionsFormArray.length) {
      this.addQuestion('add');
    }
  }

  getQuizzes() {
    this.d.getData('quizzes').subscribe((res: any) => {
      this.quizzes = res.data;
      this.loading = false;
    });
  }

  private createQuestionGroup(question?: any) {
    const options = Array.isArray(question?.options)
      ? question.options
      : question?.options
        ? [question.options]
        : [];
    const sanitizedOptions = options
      .map((opt: any) => (opt ?? '').toString().trim())
      .filter((opt: string) => !!opt);
    return this.fb.group({
      question: [question?.question || '', Validators.required],
      options: this.fb.array(sanitizedOptions.map((opt: string) => this.fb.control(opt))),
      correct_answer: [(question?.correct_answer || '').toString().trim(), Validators.required],
      optionInput: [''],
      percentage_need_to_pass: [question?.percentage_need_to_pass || 0, Validators.required]
    });
  }

  private getQuestionsArray(formType: 'add' | 'edit'): FormArray {
    return (formType === 'add' ? this.addQuizForm : this.editQuizForm).get('questions') as FormArray;
  }

  private resetFormArray(formArray: FormArray) {
    while (formArray.length) {
      formArray.removeAt(0);
    }
  }

  addQuiz() {
    this.addQuizModal = false;
    const questions = this.buildQuestionsPayload(this.questionsFormArray);
    const quiz = {
      name: this.addQuizForm.value.name,
      status: this.addQuizForm.value.status,
      distributor_id: this.addQuizForm.value.distributor_id,
      company_id: this.addQuizForm.value.company_id,
      provider_id: this.addQuizForm.value.provider_id,
      questions,
      created_by: this.currentUser.id,
      percentage_need_to_pass: this.addQuizForm.value.percentage_need_to_pass,
      video_url: this.addQuizForm.value.video_url
    };
    this.d.postData(quiz, 'quizzes/addQuiz').subscribe({
      next: (res: any) => {
        if (res.result === 'success') {
          this.message.success(res.message);
          this.getQuizzes();
          this.addQuizForm.reset({
            name: '',
            status: this.statuses[0],
            distributor_id: '',
            company_id: '',
            provider_id: '',
            percentage_need_to_pass: 0,
            video_url: ''
          });
          this.resetFormArray(this.questionsFormArray);
          this.addQuestion('add');
        } else {
          this.message.error(res.message || 'Failed to add quiz');
        }
      },
      error: (err: any) => {
        this.message.error(err.error.message || 'Failed to add quiz');
      }
    });
  }

  addQuestion(formType: 'add' | 'edit' = 'add') {
    this.getQuestionsArray(formType).push(this.createQuestionGroup());
  }

  get questionsFormArray() {
    return this.addQuizForm.get('questions') as FormArray;
  }

  get editQuestionsFormArray() {
    return this.editQuizForm.get('questions') as FormArray;
  }

  getOptionsArray(questionIndex: number, formType: 'add' | 'edit') {
    return this.getQuestionsArray(formType).at(questionIndex).get('options') as FormArray;
  }

  async handleVideoUpload(event: Event, formType: 'add' | 'edit') {
    const input = event.target as HTMLInputElement;
    const file = input?.files?.[0];
    if (!file) return;
    this.videoUploading = true;
    try {
      const url = await this.d.uploadVideo(file);
      if (url) {
        const form = formType === 'add' ? this.addQuizForm : this.editQuizForm;
        form.patchValue({ video_url: url });
        this.message.success('Video uploaded');
      } else {
        this.message.error('Failed to upload video');
      }
    } catch {
      this.message.error('Failed to upload video');
    } finally {
      this.videoUploading = false;
      if (input) {
        input.value = '';
      }
    }
  }

  clearVideo(formType: 'add' | 'edit') {
    const form = formType === 'add' ? this.addQuizForm : this.editQuizForm;
    form.patchValue({ video_url: '' });
  }

  addOption(questionIndex: number, formType: 'add' | 'edit', event?: Event) {
    event?.preventDefault();
    const questionGroup = this.getQuestionsArray(formType).at(questionIndex) as FormGroup;
    const inputControl = questionGroup.get('optionInput') as FormControl;
    const optionValue = (inputControl.value || '').trim();
    if (!optionValue) return;

    const optionsArray = questionGroup.get('options') as FormArray;
    optionsArray.push(new FormControl(optionValue));

    if (!questionGroup.get('correct_answer')?.value) {
      questionGroup.get('correct_answer')?.setValue(optionValue);
    }
    inputControl.reset();
  }

  removeOption(questionIndex: number, optionIndex: number, formType: 'add' | 'edit') {
    const questionGroup = this.getQuestionsArray(formType).at(questionIndex) as FormGroup;
    const optionsArray = questionGroup.get('options') as FormArray;
    const removedValue = optionsArray.at(optionIndex)?.value;
    optionsArray.removeAt(optionIndex);
    if (questionGroup.get('correct_answer')?.value === removedValue) {
      questionGroup.get('correct_answer')?.reset();
    }
  }

  removeLastOption(questionIndex: number, formType: 'add' | 'edit') {
    const optionsArray = this.getOptionsArray(questionIndex, formType);
    if (!optionsArray.length) return;
    const removedValue = optionsArray.at(optionsArray.length - 1)?.value;
    optionsArray.removeAt(optionsArray.length - 1);
    const questionGroup = this.getQuestionsArray(formType).at(questionIndex) as FormGroup;
    if (questionGroup.get('correct_answer')?.value === removedValue) {
      questionGroup.get('correct_answer')?.reset();
    }
  }

  removeQuestion(questionIndex: number, formType: 'add' | 'edit') {
    const questionsArray = this.getQuestionsArray(formType);
    questionsArray.removeAt(questionIndex);
  }

  private buildQuestionsPayload(formArray: FormArray) {
    return formArray.controls.map((control: any) => {
      const group = control as FormGroup;
      const optionValues = (group.get('options') as FormArray)?.value || [];
      const options = optionValues
        .map((opt: any) => (opt ?? '').toString().trim())
        .filter((opt: string) => !!opt);
      return {
        question: group.get('question')?.value,
        options,
        correct_answer: (group.get('correct_answer')?.value || '').toString().trim()
      };
    });
  }

  getDistributors() {
    this.d.getData('distributors').subscribe((res: any) => {
      this.distributors = res.data;
    });
  }

  getCompanies() {
    this.d.getData('company').subscribe((res: any) => {
      const rows = Array.isArray(res?.data) ? res.data : [];
      this.companies = this.filterCompanies(rows);
    });
  }

  getProviders() {
    this.d.getData('providers').subscribe((res: any) => {
      this.providers = res.data;
    });
  }

  getUsers() {
    this.loadingUsers = true;
    this.d.getData('users').subscribe({
      next: (res: any) => {
        const rows = Array.isArray(res)
          ? res
          : Array.isArray(res?.data)
            ? res.data
            : [];
        this.users = rows;
        this.loadingUsers = false;
      },
      error: () => {
        this.loadingUsers = false;
        this.message.error('Unable to load users');
      }
    });
  }

  private hasPermission(permission: string) {
    if (this.currentUser?.super_admin) {
      return true;
    }
    return this.currentUser?.role?.permissions?.some((p: any) => p.name === permission);
  }

  private filterCompanies(companies: any[]) {
    if (this.currentUser?.super_admin || this.hasPermission('all_company')) {
      return companies;
    }
    if (this.hasPermission('view_distributor_admin')) {
      return companies.filter((c: any) => c.distributor_id === this.currentUser?.distributor_id);
    }
    return companies.filter((c: any) => c.id === this.currentUser?.company_id);
  }

  openEdit(quiz: any) {
    this.selectedQuiz = quiz;
    this.editQuizForm.reset({
      name: quiz?.name || '',
      status: quiz?.status || this.statuses[0],
      distributor_id: quiz?.distributor_id || '',
      company_id: quiz?.company_id || '',
      provider_id: quiz?.provider_id || '',
      percentage_need_to_pass: quiz?.percentage_need_to_pass || 0,
    });
    this.resetFormArray(this.editQuestionsFormArray);
    if (quiz?.questions?.length) {
      quiz.questions.forEach((q: any) => this.editQuestionsFormArray.push(this.createQuestionGroup(q)));
    } else {
      this.addQuestion('edit');
    }
    this.editQuizForm.patchValue({ video_url: quiz?.video_url || '' });
    this.editQuizModal = true;
  }

  editQuiz() {
    const questions = this.buildQuestionsPayload(this.editQuestionsFormArray);
    const quiz = {
      id: this.selectedQuiz.id,
      name: this.editQuizForm.value.name,
      status: this.editQuizForm.value.status,
      distributor_id: this.editQuizForm.value.distributor_id,
      company_id: this.editQuizForm.value.company_id,
      provider_id: this.editQuizForm.value.provider_id,
      questions,
      percentage_need_to_pass: this.editQuizForm.value.percentage_need_to_pass,
      video_url: this.editQuizForm.value.video_url
    };
    this.d.postData(quiz, 'quizzes/editQuiz').subscribe({
      next: (res: any) => {
        if(res.result === 'success') {
          this.message.success(res.message);
          this.getQuizzes();
          this.editQuizModal = false;
          this.editQuizForm.reset();
          this.resetFormArray(this.editQuestionsFormArray);
          this.editQuizForm.patchValue({
            percentage_need_to_pass: 0
          });
          this.addQuestion('edit');
        }
      },
      error: (err: any) => {
        this.message.error(err.error.message || 'Failed to edit quiz');
      }
    });
  }

  deleteQuiz(quizId: string) {
    this.d.postData({ id: quizId }, 'quizzes/deleteQuiz').subscribe({
      next: (res: any) => {
        if(res.result === 'success') {
          this.message.success(res.message);
          this.getQuizzes();
          this.deleteQuizModal = false;
        }
      },
      error: (err: any) => {
        this.message.error(err.error.message || 'Failed to delete quiz');
      }
    });
  }

  openAssignModal(quiz: any) {
    this.selectedQuiz = quiz;
    if (!this.users?.length) {
      this.getUsers();
    }
    this.assignQuizForm.reset({ users: [] });
    this.assignQuizModal = true;
  }

  assignQuiz() {
    if (!this.assignQuizForm.valid || !this.selectedQuiz?.id) return;
    const userIds: string[] = this.assignQuizForm.value.users || [];
    if (!userIds.length) return;

    const requests = userIds.map((user_id: string) => this.d.postData({ user_id, quiz_id: this.selectedQuiz.id }, 'quizzes/assign-to-user'));
    let successCount = 0;
    let errorCount = 0;

    const processNext = (index: number) => {
      if (index >= requests.length) {
        if (successCount) {
          this.message.success(`Assigned to ${successCount} user${successCount > 1 ? 's' : ''}.`);
        }
        if (errorCount) {
          this.message.warning(`Failed to assign ${errorCount} user${errorCount > 1 ? 's' : ''}.`);
        }
        this.assignQuizModal = false;
        return;
      }
      requests[index].subscribe({
        next: (res: any) => {
          if (res?.result === 'success') {
            successCount += 1;
          } else {
            errorCount += 1;
          }
          processNext(index + 1);
        },
        error: () => {
          errorCount += 1;
          processNext(index + 1);
        }
      });
    };

    processNext(0);
  }

  openAssignCompanyModal(quiz: any) {
    this.selectedQuiz = quiz;
    this.assignCompanyForm.reset({
      company_id: this.canMultiAssignCompanies() ? [] : '',
      provider_id: 'generic',
      assign_type: 'all'
    });
    this.assignCompanyModal = true;
  }

  assignQuizToCompany() {
    if (this.assignCompanyForm.invalid || !this.selectedQuiz?.id) return;
    const companyIds = this.canMultiAssignCompanies()
      ? this.toArray(this.assignCompanyForm.value.company_id)
      : [this.assignCompanyForm.value.company_id];
    const payloadBase = {
      provider_id: this.assignCompanyForm.value.provider_id,
      assign_type: this.assignCompanyForm.value.assign_type,
      quiz_id: this.selectedQuiz.id
    };
    let successCount = 0;
    let errorCount = 0;

    const assignNext = (idx: number) => {
      if (idx >= companyIds.length) {
        if (successCount) {
          this.message.success(`Assigned to ${successCount} compan${successCount > 1 ? 'ies' : 'y'}.`);
        }
        if (errorCount) {
          this.message.warning(`Failed to assign ${errorCount} compan${errorCount > 1 ? 'ies' : 'y'}.`);
        }
        this.assignCompanyModal = false;
        return;
      }
      const payload = { ...payloadBase, company_id: companyIds[idx] };
      this.d.postData(payload, 'quizzes/assign-to-company').subscribe({
        next: (res: any) => {
          if (res?.result === 'success') {
            successCount += 1;
          } else {
            errorCount += 1;
          }
          assignNext(idx + 1);
        },
        error: () => {
          errorCount += 1;
          assignNext(idx + 1);
        }
      });
    };

    assignNext(0);
  }

  private canMultiAssignCompanies() {
    if (this.currentUser?.super_admin) return true;
    if (this.hasPermission('all_company')) return true;
    if (this.hasPermission('view_distributor_admin')) return true;
    return false;
  }

  private toArray(value: any): any[] {
    if (Array.isArray(value)) return value;
    if (value == null) return [];
    return [value];
  }
}
